import { render, staticRenderFns } from "./ApplicationMapProductSummary.vue?vue&type=template&id=28b3d4d7&scoped=true&"
import script from "./ApplicationMapProductSummary.vue?vue&type=script&lang=js&"
export * from "./ApplicationMapProductSummary.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationMapProductSummary.vue?vue&type=style&index=0&id=28b3d4d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3d4d7",
  null
  
)

export default component.exports